import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../services/firebase';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import styles from './LoginPage.module.css';

export function VerifiedPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<'verifying' | 'success_signed_in' | 'success_signed_out'>('verifying');

  useEffect(() => {
    const checkVerification = async () => {
      try {
        if (auth.currentUser) {
          await auth.currentUser.reload();
          await auth.currentUser.getIdToken(true);
          
          if (auth.currentUser.emailVerified) {
            setStatus('success_signed_in');
            setTimeout(() => {
              navigate('/dashboard', { replace: true });
            }, 2000);
            return;
          }
        }
        
        setStatus('success_signed_out');
      } catch (err) {
        console.error('Error verifying email status:', err);
        setStatus('success_signed_out');
      }
    };

    checkVerification();
  }, [navigate]);

  return (
    <div className="app">
      <Header />
      <main className={styles.loginPage}>
        <div className={styles.loginCard} style={{ textAlign: 'center' }}>
          {status === 'verifying' && (
            <>
              <h1>Verifying...</h1>
              <p>Please wait while we confirm your email verification.</p>
            </>
          )}
          
          {status === 'success_signed_in' && (
            <>
              <h1>Email Verified!</h1>
              <div className={styles.success} style={{ color: 'var(--accent)', background: 'rgba(57, 255, 20, 0.1)', padding: '12px', borderRadius: '8px', border: '1px solid var(--accent)' }}>
                Email verified successfully. Signing you in...
              </div>
            </>
          )}
          
          {status === 'success_signed_out' && (
            <>
              <h1>Email Verified!</h1>
              <div className={styles.success} style={{ color: 'var(--accent)', marginBottom: '24px', background: 'rgba(57, 255, 20, 0.1)', padding: '12px', borderRadius: '8px', border: '1px solid var(--accent)' }}>
                Email verified successfully. Please sign in to continue.
              </div>
              <button 
                className={styles.submitBtn} 
                onClick={() => navigate('/login')}
              >
                Sign In
              </button>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
